import { BannerAlert } from "@equidefi/ui";
import { useState } from "react";

import { getPlatform, isBrowserUnsupported, supportedBrowsersForPlatform } from "../helpers/browsers";

const browserList = new Intl.ListFormat("en", { style: "long", type: "disjunction" });

/**
 * Fixed banner shown at the top of the screen when the visitor is on a browser
 * or OS below our supported minimum (EPP-3426). Renders nothing for supported
 * or unidentified browsers.
 *
 * Dismissal is intentionally in-memory only: once closed it stays hidden until
 * the page is refreshed, so the user isn't pestered on every render.
 */
export const UnsupportedBrowserBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const userAgent = typeof navigator === "undefined" ? undefined : navigator.userAgent;

  if (dismissed || !isBrowserUnsupported(userAgent)) return null;

  const platform = getPlatform(userAgent);
  const supported = browserList.format(supportedBrowsersForPlatform(platform));
  const description = `The browser you are using isn't supported. For the best experience, please update to the latest version or switch to a supported browser such as ${supported}.`;

  return (
    <BannerAlert
      status="warning"
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex="banner"
      borderRadius={0}
      onClose={() => setDismissed(true)}
      data-testid="unsupported-browser-banner"
      description={description}
    />
  );
};
